import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7106c034"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "logistics-search-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "注意：地址格式必须是省市区+详细地址，否则查询结果会不准确。", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("excel导入")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-contianer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!

  return (_openBlock(), _createBlock(_component_AdminTableLayout, {
    formData: _ctx.formData,
    formLabelWidth: 100,
    searchDisabled: _ctx.loading,
    onSearch: _ctx.onSearchHandle
  }, {
    "search-info": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            "label-width": 100,
            label: "按地址查询",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                class: "logistics-search-input",
                type: "textarea",
                rows: 3,
                placeholder: "请输入查询的详细地址信息，多个地址用回车键（Enter）隔开，最多支持300条，更多数据可使用Excel导入查询 \n示例：上海上海市嘉定区铜川路2655弄\n           江苏省南通市海门市东灶港镇灵树村31",
                modelValue: _ctx.formData.address,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.address) = $event)),
                onBlur: _ctx.deleteRepeatOrderNumber
              }, null, 8, ["modelValue", "onBlur"]),
              _createElementVNode("div", {
                class: "logistics-search-box-clear",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.address = ''))
              }, " 清空 ")
            ]),
            _: 1
          }),
          _hoisted_3
        ])
      ])
    ]),
    "content-header": _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "system-btn",
        type: "primary",
        size: "mini",
        onClick: _ctx.handleExcelImport
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_ExportButton, {
        type: "abnormalFilter",
        disabled: _ctx.tableData.length<=0,
        postData: _ctx.postData
      }, null, 8, ["disabled", "postData"])
    ]),
    "content-table": _withCtx(() => [
      _hoisted_5,
      _createVNode(_component_ReportTable, {
        loading: _ctx.loading,
        tableData: _ctx.tableData,
        showTableColumn: _ctx.showTableColumn
      }, {
        abnormalArea: _withCtx(({ row }) => [
          _createElementVNode("span", {
            class: _normalizeClass({ 'color-red': row.isAbnormalArea=='不可达' })
          }, _toDisplayString(row.isAbnormalArea), 3)
        ]),
        _: 1
      }, 8, ["loading", "tableData", "showTableColumn"])
    ]),
    _: 1
  }, 8, ["formData", "searchDisabled", "onSearch"]))
}